import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { useCartOpenState, useCartQuery } from '../../hooks/useCart';

const CartButton = () => {
  const { data: cart } = useCartQuery();
  const { open } = useCartOpenState();

  const lineCount = cart?.lines?.length || 0;

  return (
    <Button
      variant="ghost"
      size="icon"
      className="relative h-10 w-10"
      onClick={open}
      aria-label="Open cart"
    >
      <ShoppingCart className="h-5 w-5" />
      {lineCount > 0 && (
        <Badge
          variant="destructive"
          className="absolute -top-1 -right-1 h-5 w-5 p-0 flex items-center justify-center text-xs"
        >
          {lineCount}
        </Badge>
      )}
    </Button>
  );
};

export default CartButton;
